var React = require('react');
var ReactNative = require('react-native');



var Animated = require('./wrappers/Animated')

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKTextField,
} = MK;

var {
  AppRegistry,
  Text,
  StyleSheet,
  View,
  Platform,
    TextInput
} = ReactNative;

var ReUpField = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      isInError: false,
      onChangeText: function(){},
      useGeneric:false,
      hideLine:false,
      disableBackground:false,
      textInputStyle:{},
      invertBG:false
    }
  },

  getInitialState : function()
  {
    return {
      isInError : this.props.isInError,
      text : typeof this.props.defaultValue !== 'undefined' ? this.props.defaultValue : ""
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.isInError !== 'undefined' && newProps.isInError != this.state.isInError )
    {
      this.setState({isInError:newProps.isInError})
    }
    if( typeof newProps.defaultValue !== 'undefined' && newProps.defaultValue != this.state.text )
    {
      this.setState({text:newProps.defaultValue})
    }
    if( typeof newProps.value !== 'undefined' && newProps.value != this.state.text )
    {
      this.setState({text:newProps.value})
    }
  },

  focus : function()
  {
    this._ref_field.focus();
  },

  isInError : function()
  {
    return this.state.isInError;
  },

  setIsInError : function(isInError)
  {
    this.setState({isInError : isInError});
  },

  onChangeText : function(text)
  {
    this.props.onChangeText(text);
    this.setText(text);

    // hack to fix error color
    if( typeof this._ref_field.refs.floatingLabel !== 'undefined' ) this._ref_field.refs.floatingLabel.aniFloatLabel();
  },

  setText : function(text)
  {
    this.setState({text});
  },

  onBlur : function()
  {
    this._ref_field.focus();
  },

  render: function()
  {
    var {text, appManager, onChangeText, style, useGeneric, textInputStyle, hideLine, secureTextEntry, ...other} = this.props;
    style = typeof style !== 'undefined' ? style : {};

    var thisThing = this;
    var bgColor = appManager.getColorForKey("GeneralTitleColor", .03);
    if( this.props.invertBG ) bgColor = appManager.getColorForKey("GeneralColor", 1);
    var generalColor = useGeneric ? 'white' : appManager.getColorForKey("GeneralColor");
    var generalTitleColor = useGeneric ? 'black' : appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = useGeneric ? 'black' : appManager.getColorForKey("FeedCardBannerColor");
    if( bannerColor == generalColor ) bannerColor = generalTitleColor;

    if( Platform.OS == 'web' ) other.tabindex = "-1";

    return (
      <View style={[{height:60, flexDirection:'column'},style]} onStartShouldSetResponder={(evt) => {thisThing._ref_field.focus()}}>
        <MKTextField
          ref={(c) => { this._ref_field = c; }}
          underlineColorAndroid='transparent'
          onChangeText={this.onChangeText}
          allowFontScaling={false}
          tintColor={this.state.isInError ? 'red' : hideLine ? 'transparent' : generalTitleColor}
          highlightColor={this.state.isInError ? 'red' : hideLine ? 'transparent' : bannerColor}
          textInputStyle={[
          {
            color: generalTitleColor,
            fontSize:16,
            fontFamily: 'Arial',
            flex:1,
            padding:6,
            backgroundColor:this.props.disableBackground ? 'transparent' : bgColor
          }, textInputStyle]}
          floatingLabelEnabled={true}
          floatingLabelAniDuration={100}
          placeholderTextColor={'grey'}
          floatingLabelFont={{
              fontSize: 12,
              fontStyle: 'italic',
                fontWeight: '200',
              paddingRight:10,
            }}
          style={[
            {
              flex:1,
              borderRadius: 3,
              backgroundColor: 'white',
              padding: 8

            }]}
          password={secureTextEntry}
          value={this.state.text}
          text={this.state.text}
            {...other}/>
        </View>
    )
  }
});

module.exports = ReUpField;
